import { useState, useEffect } from 'react';
import supabase from '@/lib/supabase';
export interface HospitalSchedule {
  day: string;
  hours: string;
}

export interface HospitalInfo {
  id: string;
  name: string;
  description: string;
  mission: string;
  vision: string;
  address: string;
  phone: string;
  email: string;
  website?: string;
  logo?: string;
  image?: string;
  departments: Array<{ id: string; name: string; description: string }>;
  services: Array<{ id: string; name: string; description: string }>;
  schedule: HospitalSchedule[];
  social_links?: {
    twitter?: string;
    facebook?: string;
    instagram?: string;
    linkedin?: string;
  };
  last_updated: string;
  created_at: string;
}

export function useHospitalInfo() {
  const [hospitalInfo, setHospitalInfo] = useState<HospitalInfo | null>(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    const fetchHospitalInfo = async () => {
      try {
        const { data, error } = await supabase
          .from('hospital_info')
          .select('*')
          .single();

        if (error) {
          throw error;
        }

        setHospitalInfo(data);
      } catch (err) {
        console.error('Error fetching hospital info:', err);
        setError(err instanceof Error ? err.message : 'Failed to fetch hospital info');
      } finally {
        setLoading(false);
      }
    };

    fetchHospitalInfo();
  }, []);

  return { hospitalInfo, loading, error };
}